import React from "react";

export const TogglerContext = React.createContext({});
export const HistoryTogglerContext = React.createContext({});
export const SetItemContext = React.createContext({});
